/** @type {string} */
const dropdownComponent = 'Dropdown';
export default dropdownComponent;
